import React, {Component} from 'react';
import {translateLang} from "../../../constants/traductions";
import {connect} from "react-redux";

class CalendarDaysHeader extends Component {

  capitalize(str){
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  render() {
    return (
      <section className="calendar-row">
        <div className="calendar-day day-name">{ this.capitalize(translateLang('dia_1', this.props.store.language).substring(0,3)) }</div>
        <div className="calendar-day day-name">{ this.capitalize(translateLang('dia_2', this.props.store.language).substring(0,3)) }</div>
        <div className="calendar-day day-name">{ this.capitalize(translateLang('dia_3', this.props.store.language).substring(0,3)) }</div>
        <div className="calendar-day day-name">{ this.capitalize(translateLang('dia_4', this.props.store.language).substring(0,3)) }</div>
        <div className="calendar-day day-name">{ this.capitalize(translateLang('dia_5', this.props.store.language).substring(0,3)) }</div>
        <div className="calendar-day day-name">{ this.capitalize(translateLang('dia_6', this.props.store.language).substring(0,3)) }</div>
        <div className="calendar-day day-name">{ this.capitalize(translateLang('dia_7', this.props.store.language).substring(0,3)) }</div>
      </section>
    );
  }
}

const mapStateToProps = store => ({
  store
});

export default connect(mapStateToProps, null)(CalendarDaysHeader);
